import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { filter, map, take } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { UserRole } from '../core/types/user.types';

export const roleGuard = (allowedRoles: UserRole[]) => {
  return () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.initialized$.pipe(
      filter(initialized => initialized),
      take(1),
      map(() => {
        if (!authService.isAuthenticated()) {
          console.log('🚫 Role Guard: Not authenticated');
          return router.createUrlTree(['/sign-in']);
        }

        const userRole = authService.profile()?.role;
        console.log('🔐 Role Guard: User role:', userRole, '| Allowed roles:', allowedRoles);
        
        if (userRole && allowedRoles.includes(userRole)) {
          console.log('✅ Role Guard: Access granted');
          return true;
        }

        console.log('❌ Role Guard: Access denied, redirecting to dashboard');
        return router.createUrlTree(['/']);
      })
    );
  };
};
